import { diInject } from 'stores/diContext';
import { EventService } from '../services/events';
import { observable, computed } from 'mobx';
import { TicketsStore, TicketItemStore } from './ticket';
import { DonationsStore, DonationItemStore } from "./donation";
import { OrderStore } from "./order";
import { CartStore } from "./cart";
import * as queryString from "utils/queryString";
import { AppStore } from "stores/app";
import { SparxoClientHost } from 'Apps/shared/ClientHost';
/**
 * 活动售票状态
 */
export const EventStatus = {
    Loading:"loading",
    NotFound: 'not-found',
    Ready: 'ready',
    Done:'done'
}

export const SellStatus = {
    Loading: "loading",
    NotPaymentMethod:"not-payment-method",
    NotStarted: "not-started",
    Over: "over",
    InSale: "in-sell"
}

/**
 * 活动以及购票Store
 */
export class EventStore {

    @diInject() eventService: EventService;

    //购物车
    @diInject() cartStore: CartStore;

    //多语言服务
    @diInject() app: AppStore;
    //订单
    @diInject() orderStore: OrderStore;

    //票
    @diInject() ticketsStore: TicketsStore;

    //捐赠
    @diInject() donationsStore: DonationsStore;
    @diInject() clientHost: SparxoClientHost;

    currency: string = "USD";

    pk: string;

    //EventStore 状态
    @observable status = EventStatus.Loading;
    //活动
    event: IEventResult = null;


    last_event_id: string;

    event_id: string;

    event_schedule_id: string;

    show_tickets = false;

    shareParams: { __rn__?, referral_user_name?, share_id?} = {};

    urlCoupon = null;
    
    urlVip= null;

    @observable sell_status = SellStatus.Loading;

    //服务器当前时间
    @observable utcNow = null;

    //#region api请求
    /**
     * 获取当前服务器时间
     */
    async getSystemInfo() {
        const system_info = await this.eventService.getSystemInfo();
        this.utcNow = system_info.now_utc;
        return this.utcNow;
    }
    /**
     * 加载活动信息
     * @param event_id
     */
    async loadEvent(event_id) {
        this.last_event_id = this.event_id;
        this.status = EventStatus.Loading;
        try {
            var event = await this.eventService.get(event_id);
            if (event == null) {
                this.status = EventStatus.NotFound;
                this.event = null;
                return;
            }
            if (event.status!="Open") {
                this.status = EventStatus.NotFound;
                this.event = null;
                return;
            }
            this.show_tickets = event.show_tickets;
            //当前的活动ID
            this.event_id = event.id;
            //当前阶段ID
            this.event_schedule_id = event.schedules[0].id;

            if (event.merchant) {
                this.currency = event.merchant.currency;
                var settings: Array<any> = event.merchant.payment_method_settings;
                var method = settings.find((s) => {
                    return s.payment_method == "StripeTokenDirect";
                });
                if (method) {
                    this.pk = method.connect_public_key;
                }else{
                    this.pk=null;
                }
                if (event.merchant.lang) {
                    this.app.setLanguage(event.merchant.lang)
                }
            }
            this.event = event;
            this.status = EventStatus.Ready;
            if (this.clientHost.context.loaded) {
                this.clientHost.context.loaded();
            }
        }
        catch (ex) {
            if (ex && ex.statusText != "abort") {
                this.status = EventStatus.NotFound;
                this.event = null;
            }
        }
    }

    /**
     * 重置买票Store，一般在买票结束后，再次购买之前
     * @param reload 是否强制刷新
     */
    async loadSoldInfo(filter?) {
        if (!filter) {
            filter = this.clientHost.options.filter;
        }
        if (!this.event) {
            return;
        }
        if (!this.pk && !this.event.is_rsvp) {
            this.sell_status=SellStatus.NotPaymentMethod;
            return;
        }
        this.sell_status = SellStatus.Loading;
        this.cartStore.clear();
        this.orderStore.clear();
        await this.getSystemInfo();

        const task2 = this.ticketsStore.loadTicketSoldInfo(filter);
        const task3 = this.donationsStore.loadDonationInfo();
        await task2;
        await task3;
        let sell_status = SellStatus.InSale;
        if (this.donationsStore.donations.length == 0 &&
            this.ticketsStore.visibleCount() == 0) {
            if (this.ticketsStore.isNotStarted) {
                sell_status = SellStatus.NotStarted;
            }
            if (this.ticketsStore.isOver) {
                sell_status = SellStatus.Over;
            }
        } else {
            this.ticketsStore.tryAddDefaultQuantity();
        }
        this.sell_status = sell_status;
    }

    viewpage(search, default_rn) {
        search = search.replace(/^\?/, "");
        
        // next line get queryParams from parent in integration iframe's
        const referrer = document.referrer.split('?')[1];
        var queryParams: any = queryString.resolve(referrer ? referrer : search);
        var __rn__ = queryParams.rn;
        var __coupon__ = queryParams.code;
        var __couponVip__ = queryParams.vip;
        var referral_user_name = queryParams.rn || default_rn, share_id = queryParams.shareid;

        if (/^https?:\/\//.test(referral_user_name)) {
            referral_user_name = referral_user_name.split("?")[0];
        }
        
        if (referral_user_name.length > 240) {
            referral_user_name = referral_user_name.substr(0, 237) + "...";
        }
        
        if (__coupon__) {
            this.urlCoupon = __coupon__;
        }
    
        if (__couponVip__) {
            this.urlVip = __couponVip__;
        }

        this.shareParams = { __rn__, referral_user_name, share_id };

        // if (!__DEV__) {
            this.eventService.viewpage(this.event_id, this.shareParams);
        // } else {
        //     console.log("viewpage", this.shareParams);
        // }
    }

    checkout() {
        this.orderStore.checkout();
    }

    clear() {
        this.event = null;
        this.status = EventStatus.Loading;
    }
}

export default EventStore;



// WEBPACK FOOTER //
// ./src/Apps/ticketing/stores/events.ts